import { useRef } from 'react';
import styles from './textarea.module.scss';

interface TextareaProps {
  label?: string;
  value: string;
  placeholder: string;
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLTextAreaElement, Element>) => void;
}

const Textarea: React.FC<TextareaProps> = ({ label, placeholder, value, className, onChange, onFocus }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  
  const classes = `
  ${styles.textarea} 
  ${className || ''}`.trim();

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
    onChange(e);
  };

  return (
    <div className={classes}>
      {!!label && <span className={styles.label}>{label}</span>}
      <textarea ref={textareaRef} placeholder={placeholder} onChange={handleInputChange} value={value} onFocus={onFocus}/>
    </div>
  );
};

export default Textarea;
